import type { ClientRelationWorklog } from '../models';
import type { TimeFormat, TimeZone } from './TimeSettingsDropDown';
import WorklogDetailsInfo from './WorklogDetailsInfo';

export type WorklogInfoProps = {
  value: ClientRelationWorklog;
  timeZone: TimeZone;
  timeFormat: TimeFormat;
};

const WorklogInfo = (props: WorklogInfoProps) => (
  <div>
    <WorklogDetailsInfo {...props} />
  </div>
);

export default WorklogInfo;
